export const STEPS = ["I Tuoi Dati", "Dettagli Abitazione"];

export const PROVINCE = [
  { value: "MI", label: "Milano" },
  { value: "RM", label: "Roma" },
  { value: "NA", label: "Napoli" },
  { value: "TO", label: "Torino" },
  { value: "FI", label: "Firenze" },
  { value: "BO", label: "Bologna" },
];

export const TIPI_ABITAZIONE = [
  "Appartamento",
  "Villa",
  "Villetta",
  "Attico",
  "Loft",
];

export const GARANZIE = {
  incendio: "Incendio",
  furto: "Furto",
  danniAcqua: "Danni da Acqua",
  responsabilitaCivile: "Responsabilità Civile",
};

export const INITIAL_FORM_DATA = {
  nome: "",
  cognome: "",
  email: "",
  telefono: "",
  provincia: "",
  indirizzo: "",
  tipoAbitazione: "",
  metriQuadri: "",
  annoCostruzione: "",
  garanzie: {
    incendio: true,
    furto: true,
    danniAcqua: false,
    responsabilitaCivile: false,
  },
};

export const INITIAL_ERRORS = {
  nome: false,
  cognome: false,
  email: false,
  telefono: false,
  tipoAbitazione: false,
  metriQuadri: false,
  annoCostruzione: false,
};
